unit Check;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, StrUtils,
  WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, TerminalForm,
  Vcl.Controls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection,
  WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, WEBLib.Buttons,
  WEBLib.CDS, WEBLib.WebCtrls;

type
  TfrmCheck = class(TTerminalForm)
    tmrStart: TTimer;
    srcView: TDataSource;
    wdsView: TXDataWebDataSet;
    lblDolzina: TDBLabel;
    lblSirina: TDBLabel;
    lblPogodbaSt: TDBLabel;
    lblPogodbaOd: TDBLabel;
    lblPogodbaDo: TDBLabel;
    lblOpombe: TDBLabel;
    wdsViewPristanisce: TXDataWebEntityField;
    wdsViewPristanisceId: TIntegerField;
    wdsViewPristanisceNaziv: TStringField;
    wdsViewPristaniscePaOddelek: TStringField;
    wdsViewPristanisceExtraDolzinaCenaBrezDDV: TFloatField;
    wdsViewTipPriveza: TXDataWebEntityField;
    wdsViewTipPrivezaId: TIntegerField;
    wdsViewTipPrivezaNaziv: TStringField;
    wdsViewOpombeList: TXDataWebDatasetField;
    wdsViewId: TIntegerField;
    wdsViewZapSt: TIntegerField;
    wdsViewRegSt: TStringField;
    wdsViewRegStCista: TStringField;
    wdsViewDelezLastnistva: TStringField;
    wdsViewDolzina: TFloatField;
    wdsViewSirina: TFloatField;
    wdsViewGlobina: TFloatField;
    wdsViewPantheonId: TStringField;
    wdsViewPriimekIme: TStringField;
    wdsViewPogodbaSt: TStringField;
    wdsViewPogodbaOd: TDateTimeField;
    wdsViewPogodbaDo: TDateTimeField;
    wdsViewZadnjiAneks: TDateTimeField;
    wdsViewOpombe: TStringField;
    wdsViewObracun: TBooleanField;
    wdsViewActive: TBooleanField;
    wdsViewadTimeChg: TDateTimeField;
    wdsViewadTimeIns: TDateTimeField;
    lblPrivez: TDBLabel;
    wdsViewPrivez: TXDataWebEntityField;
    wdsViewPrivezPristanisce: TXDataWebEntityField;
    wdsViewPrivezId: TIntegerField;
    wdsViewPrivezZapSt: TIntegerField;
    wdsViewanUserChg2: TStringField;
    wdsViewanUserIns: TStringField;
    lblLastnik: TDBLabel;
    lblNoData: TLabel;
    btnFind: TButton;
    btnPristanisce: TButton;
    edtFind: TEdit;
    lblRegSt: TDBLabel;
    wdsViewTel: TStringField;
    wdsViewTel2: TStringField;
    lblTel2: TLinkLabel;
    procedure FormShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure tmrStartTimer(Sender: TObject);
    procedure btnFindClick(Sender: TObject);
    procedure wdsViewAfterOpen(DataSet: TDataSet);
    procedure edtFindDblClick(Sender: TObject);
    procedure btnPristanisceClick(Sender: TObject);
    procedure btnFindKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
  private
    { Private declarations }
    procedure ApplyTheme(Dark: boolean); reintroduce;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmCheck: TfrmCheck;

implementation

{$R *.dfm}

uses Main, Client.Core, Auth.Service, Client.Constants;

procedure TfrmCheck.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Action := caFree;
end;

procedure TfrmCheck.btnFindClick(Sender: TObject);
var Qry: string;
begin
  inherited;

  if edtFind.Text='' then
    exit;

  // Ugotovi, ali gre za privez ali za registrsko tablico - če ima črko ali je daljša od 3 znake, je tablica
  if (edtFind.Text.Length>4) or (StrToIntDef(edtFind.Text, -1) < 0) then
    Qry := '$filter=Pristanisce eq '''+ modMain.PristanisceId.ToString+''' and (RegSt eq '''+edtFind.Text+''' or RegStCista eq '''+edtFind.Text+''')' // Registrka
  else
    Qry := '$filter=Pristanisce eq '''+ modMain.PristanisceId.ToString+''' and Privez eq '''+edtFind.Text+''''; // Privez

  Qry := Qry + '&$top=1&$expand=TipPriveza';

  // Pošlji poizvedbo
  wdsView.Close;
  wdsView.QueryString := Qry;
  Log('Pošiljanje poizvedbe: ' + wdsView.QueryString);
  wdsView.Load;
end;

procedure TfrmCheck.btnFindKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  inherited;
  if Key=VK_RETURN then
    btnFind.Click;
end;

procedure TfrmCheck.btnPristanisceClick(Sender: TObject);
begin
  inherited;
  frmMain.ShowPristanisce;
end;

procedure TfrmCheck.edtFindDblClick(Sender: TObject);
begin
  inherited;
  frmMain.ShowScan;
end;

procedure TfrmCheck.FormShow(Sender: TObject);
begin
  inherited;
  
  ApplyTheme(frmMain.DarkMode);
end;

procedure TfrmCheck.tmrStartTimer(Sender: TObject);
begin
  tmrStart.Enabled := false;
end;

procedure TfrmCheck.wdsViewAfterOpen(DataSet: TDataSet);
var noData: boolean;
    Tel: string;
begin
  inherited;
  noData := wdsView.RecordCount = 0;

  Log('Rezultat: '+IntToStr(wdsView.RecordCount)+' vrstic');

  lblNoData.Visible := true;

  lblNoData.ElementClassName := IfThen(noData, 'alert alert-warning h2 text-center', 'alert alert-success h2 text-center');
  lblNoData.Caption := IfThen(noData, 'Privez je prost', 'Privez je zaseden');

  Tel := (DataSet.FieldByName('Tel').AsString).Replace(' ', '').Replace('-', '').Replace('/', '');

  lblTel2.Caption := '<a href="tel:'+Tel+'">'+DataSet.FieldByName('Tel').AsString+'</a>';

  edtFind.Clear;
end;

procedure TfrmCheck.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmCheck.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblDolzina := TDBLabel.Create('lblDolzina');
  lblSirina := TDBLabel.Create('lblSirina');
  lblPogodbaSt := TDBLabel.Create('lblPogodbaSt');
  lblPogodbaOd := TDBLabel.Create('lblPogodbaOd');
  lblPogodbaDo := TDBLabel.Create('lblPogodbaDo');
  lblOpombe := TDBLabel.Create('lblOpombe');
  lblPrivez := TDBLabel.Create('lblPrivez');
  lblLastnik := TDBLabel.Create('lblLastnik');
  lblNoData := TLabel.Create('lblNoData');
  lblRegSt := TDBLabel.Create('lblRegSt');
  lblTel2 := TLinkLabel.Create('lblTel');
  btnFind := TButton.Create('btnFind');
  btnPristanisce := TButton.Create('btnPristanisce');
  edtFind := TEdit.Create('edtFind');
  tmrStart := TTimer.Create(Self);
  srcView := TDataSource.Create(Self);
  wdsView := TXDataWebDataSet.Create(Self);
  wdsViewPristanisce := TXDataWebEntityField.Create(Self);
  wdsViewPristanisceId := TIntegerField.Create(Self);
  wdsViewPristanisceNaziv := TStringField.Create(Self);
  wdsViewPristaniscePaOddelek := TStringField.Create(Self);
  wdsViewPristanisceExtraDolzinaCenaBrezDDV := TFloatField.Create(Self);
  wdsViewTipPriveza := TXDataWebEntityField.Create(Self);
  wdsViewTipPrivezaId := TIntegerField.Create(Self);
  wdsViewTipPrivezaNaziv := TStringField.Create(Self);
  wdsViewOpombeList := TXDataWebDatasetField.Create(Self);
  wdsViewId := TIntegerField.Create(Self);
  wdsViewZapSt := TIntegerField.Create(Self);
  wdsViewRegSt := TStringField.Create(Self);
  wdsViewRegStCista := TStringField.Create(Self);
  wdsViewDelezLastnistva := TStringField.Create(Self);
  wdsViewDolzina := TFloatField.Create(Self);
  wdsViewSirina := TFloatField.Create(Self);
  wdsViewGlobina := TFloatField.Create(Self);
  wdsViewPantheonId := TStringField.Create(Self);
  wdsViewPriimekIme := TStringField.Create(Self);
  wdsViewPogodbaSt := TStringField.Create(Self);
  wdsViewPogodbaOd := TDateTimeField.Create(Self);
  wdsViewPogodbaDo := TDateTimeField.Create(Self);
  wdsViewZadnjiAneks := TDateTimeField.Create(Self);
  wdsViewOpombe := TStringField.Create(Self);
  wdsViewObracun := TBooleanField.Create(Self);
  wdsViewActive := TBooleanField.Create(Self);
  wdsViewadTimeChg := TDateTimeField.Create(Self);
  wdsViewadTimeIns := TDateTimeField.Create(Self);
  wdsViewanUserChg2 := TStringField.Create(Self);
  wdsViewPrivez := TXDataWebEntityField.Create(Self);
  wdsViewPrivezPristanisce := TXDataWebEntityField.Create(Self);
  wdsViewPrivezId := TIntegerField.Create(Self);
  wdsViewPrivezZapSt := TIntegerField.Create(Self);
  wdsViewanUserIns := TStringField.Create(Self);
  wdsViewTel := TStringField.Create(Self);
  wdsViewTel2 := TStringField.Create(Self);

  lblDolzina.BeforeLoadDFMValues;
  lblSirina.BeforeLoadDFMValues;
  lblPogodbaSt.BeforeLoadDFMValues;
  lblPogodbaOd.BeforeLoadDFMValues;
  lblPogodbaDo.BeforeLoadDFMValues;
  lblOpombe.BeforeLoadDFMValues;
  lblPrivez.BeforeLoadDFMValues;
  lblLastnik.BeforeLoadDFMValues;
  lblNoData.BeforeLoadDFMValues;
  lblRegSt.BeforeLoadDFMValues;
  lblTel2.BeforeLoadDFMValues;
  btnFind.BeforeLoadDFMValues;
  btnPristanisce.BeforeLoadDFMValues;
  edtFind.BeforeLoadDFMValues;
  tmrStart.BeforeLoadDFMValues;
  srcView.BeforeLoadDFMValues;
  wdsView.BeforeLoadDFMValues;
  wdsViewPristanisce.BeforeLoadDFMValues;
  wdsViewPristanisceId.BeforeLoadDFMValues;
  wdsViewPristanisceNaziv.BeforeLoadDFMValues;
  wdsViewPristaniscePaOddelek.BeforeLoadDFMValues;
  wdsViewPristanisceExtraDolzinaCenaBrezDDV.BeforeLoadDFMValues;
  wdsViewTipPriveza.BeforeLoadDFMValues;
  wdsViewTipPrivezaId.BeforeLoadDFMValues;
  wdsViewTipPrivezaNaziv.BeforeLoadDFMValues;
  wdsViewOpombeList.BeforeLoadDFMValues;
  wdsViewId.BeforeLoadDFMValues;
  wdsViewZapSt.BeforeLoadDFMValues;
  wdsViewRegSt.BeforeLoadDFMValues;
  wdsViewRegStCista.BeforeLoadDFMValues;
  wdsViewDelezLastnistva.BeforeLoadDFMValues;
  wdsViewDolzina.BeforeLoadDFMValues;
  wdsViewSirina.BeforeLoadDFMValues;
  wdsViewGlobina.BeforeLoadDFMValues;
  wdsViewPantheonId.BeforeLoadDFMValues;
  wdsViewPriimekIme.BeforeLoadDFMValues;
  wdsViewPogodbaSt.BeforeLoadDFMValues;
  wdsViewPogodbaOd.BeforeLoadDFMValues;
  wdsViewPogodbaDo.BeforeLoadDFMValues;
  wdsViewZadnjiAneks.BeforeLoadDFMValues;
  wdsViewOpombe.BeforeLoadDFMValues;
  wdsViewObracun.BeforeLoadDFMValues;
  wdsViewActive.BeforeLoadDFMValues;
  wdsViewadTimeChg.BeforeLoadDFMValues;
  wdsViewadTimeIns.BeforeLoadDFMValues;
  wdsViewanUserChg2.BeforeLoadDFMValues;
  wdsViewPrivez.BeforeLoadDFMValues;
  wdsViewPrivezPristanisce.BeforeLoadDFMValues;
  wdsViewPrivezId.BeforeLoadDFMValues;
  wdsViewPrivezZapSt.BeforeLoadDFMValues;
  wdsViewanUserIns.BeforeLoadDFMValues;
  wdsViewTel.BeforeLoadDFMValues;
  wdsViewTel2.BeforeLoadDFMValues;
  try
    Caption := 'test';
    Color := clBtnFace;
    ElementPosition := epIgnore;
    Font.Height := -21;
    SetEvent(Self, 'OnCreate', 'btnFindClick');
    lblDolzina.SetParentComponent(Self);
    lblDolzina.Name := 'lblDolzina';
    lblDolzina.Left := 8;
    lblDolzina.Top := 169;
    lblDolzina.Width := 138;
    lblDolzina.Height := 38;
    lblDolzina.AutoSize := False;
    lblDolzina.Color := clBtnFace;
    lblDolzina.ElementFont := efCSS;
    lblDolzina.ElementPosition := epIgnore;
    lblDolzina.HeightPercent := 100.000000000000000000;
    lblDolzina.WidthPercent := 100.000000000000000000;
    lblDolzina.DataField := 'Dolzina';
    lblDolzina.DataSource := srcView;
    lblSirina.SetParentComponent(Self);
    lblSirina.Name := 'lblSirina';
    lblSirina.Left := 449;
    lblSirina.Top := 169;
    lblSirina.Width := 180;
    lblSirina.Height := 38;
    lblSirina.AutoSize := False;
    lblSirina.Color := clBtnFace;
    lblSirina.ElementFont := efCSS;
    lblSirina.ElementPosition := epIgnore;
    lblSirina.HeightPercent := 100.000000000000000000;
    lblSirina.WidthPercent := 100.000000000000000000;
    lblSirina.DataField := 'Sirina';
    lblSirina.DataSource := srcView;
    lblPogodbaSt.SetParentComponent(Self);
    lblPogodbaSt.Name := 'lblPogodbaSt';
    lblPogodbaSt.Left := 8;
    lblPogodbaSt.Top := 240;
    lblPogodbaSt.Width := 425;
    lblPogodbaSt.Height := 39;
    lblPogodbaSt.Anchors := [akLeft,akTop,akRight];
    lblPogodbaSt.AutoSize := False;
    lblPogodbaSt.Color := clBtnFace;
    lblPogodbaSt.ElementFont := efCSS;
    lblPogodbaSt.ElementPosition := epIgnore;
    lblPogodbaSt.HeightPercent := 100.000000000000000000;
    lblPogodbaSt.WidthPercent := 100.000000000000000000;
    lblPogodbaSt.DataField := 'PogodbaSt';
    lblPogodbaSt.DataSource := srcView;
    lblPogodbaOd.SetParentComponent(Self);
    lblPogodbaOd.Name := 'lblPogodbaOd';
    lblPogodbaOd.Left := 8;
    lblPogodbaOd.Top := 312;
    lblPogodbaOd.Width := 180;
    lblPogodbaOd.Height := 54;
    lblPogodbaOd.AutoSize := False;
    lblPogodbaOd.Color := clBtnFace;
    lblPogodbaOd.ElementFont := efCSS;
    lblPogodbaOd.ElementPosition := epIgnore;
    lblPogodbaOd.HeightPercent := 100.000000000000000000;
    lblPogodbaOd.WidthPercent := 100.000000000000000000;
    lblPogodbaOd.DataField := 'PogodbaOd';
    lblPogodbaOd.DataSource := srcView;
    lblPogodbaDo.SetParentComponent(Self);
    lblPogodbaDo.Name := 'lblPogodbaDo';
    lblPogodbaDo.Left := 456;
    lblPogodbaDo.Top := 312;
    lblPogodbaDo.Width := 173;
    lblPogodbaDo.Height := 54;
    lblPogodbaDo.Anchors := [akTop,akRight];
    lblPogodbaDo.AutoSize := False;
    lblPogodbaDo.Color := clBtnFace;
    lblPogodbaDo.ElementFont := efCSS;
    lblPogodbaDo.ElementPosition := epIgnore;
    lblPogodbaDo.HeightPercent := 100.000000000000000000;
    lblPogodbaDo.WidthPercent := 100.000000000000000000;
    lblPogodbaDo.DataField := 'PogodbaDo';
    lblPogodbaDo.DataSource := srcView;
    lblOpombe.SetParentComponent(Self);
    lblOpombe.Name := 'lblOpombe';
    lblOpombe.Left := 8;
    lblOpombe.Top := 399;
    lblOpombe.Width := 621;
    lblOpombe.Height := 370;
    lblOpombe.Anchors := [akLeft,akTop,akRight,akBottom];
    lblOpombe.AutoSize := False;
    lblOpombe.Color := clBtnFace;
    lblOpombe.ElementFont := efCSS;
    lblOpombe.ElementPosition := epIgnore;
    lblOpombe.HeightPercent := 100.000000000000000000;
    lblOpombe.WordWrap := True;
    lblOpombe.WidthPercent := 100.000000000000000000;
    lblOpombe.DataField := 'Opombe';
    lblOpombe.DataSource := srcView;
    lblPrivez.SetParentComponent(Self);
    lblPrivez.Name := 'lblPrivez';
    lblPrivez.Left := 456;
    lblPrivez.Top := 240;
    lblPrivez.Width := 173;
    lblPrivez.Height := 39;
    lblPrivez.Anchors := [akTop,akRight];
    lblPrivez.AutoSize := False;
    lblPrivez.Color := clBtnFace;
    lblPrivez.ElementFont := efCSS;
    lblPrivez.ElementPosition := epIgnore;
    lblPrivez.HeightPercent := 100.000000000000000000;
    lblPrivez.WidthPercent := 100.000000000000000000;
    lblPrivez.DataField := 'Privez';
    lblPrivez.DataSource := srcView;
    lblLastnik.SetParentComponent(Self);
    lblLastnik.Name := 'lblLastnik';
    lblLastnik.Left := 8;
    lblLastnik.Top := 66;
    lblLastnik.Width := 621;
    lblLastnik.Height := 38;
    lblLastnik.Anchors := [akLeft,akTop,akRight];
    lblLastnik.AutoSize := False;
    lblLastnik.Color := clBtnFace;
    lblLastnik.ElementFont := efCSS;
    lblLastnik.ElementPosition := epIgnore;
    lblLastnik.HeightPercent := 100.000000000000000000;
    lblLastnik.WidthPercent := 100.000000000000000000;
    lblLastnik.DataField := 'PriimekIme';
    lblLastnik.DataSource := srcView;
    lblNoData.SetParentComponent(Self);
    lblNoData.Name := 'lblNoData';
    lblNoData.Left := 248;
    lblNoData.Top := 162;
    lblNoData.Width := 16;
    lblNoData.Height := 21;
    lblNoData.Alignment := taCenter;
    lblNoData.Caption := '    ';
    lblNoData.Color := clBtnFace;
    lblNoData.ElementFont := efCSS;
    lblNoData.Font.Charset := DEFAULT_CHARSET;
    lblNoData.Font.Color := clWindowText;
    lblNoData.Font.Height := -16;
    lblNoData.Font.Name := 'Segoe UI';
    lblNoData.Font.Style := [];
    lblNoData.HeightStyle := ssAuto;
    lblNoData.HeightPercent := 100.000000000000000000;
    lblNoData.Layout := tlCenter;
    lblNoData.ParentFont := False;
    lblNoData.Transparent := False;
    lblNoData.Visible := False;
    lblNoData.WidthPercent := 100.000000000000000000;
    lblRegSt.SetParentComponent(Self);
    lblRegSt.Name := 'lblRegSt';
    lblRegSt.Left := 192;
    lblRegSt.Top := 169;
    lblRegSt.Width := 138;
    lblRegSt.Height := 38;
    lblRegSt.AutoSize := False;
    lblRegSt.Color := clBtnFace;
    lblRegSt.ElementFont := efCSS;
    lblRegSt.ElementPosition := epIgnore;
    lblRegSt.HeightStyle := ssAuto;
    lblRegSt.HeightPercent := 100.000000000000000000;
    lblRegSt.WidthPercent := 100.000000000000000000;
    lblRegSt.DataField := 'RegSt';
    lblRegSt.DataSource := srcView;
    lblTel2.SetParentComponent(Self);
    lblTel2.Name := 'lblTel2';
    lblTel2.Left := 28;
    lblTel2.Top := 118;
    lblTel2.Width := 396;
    lblTel2.Height := 30;
    lblTel2.Color := clBtnFace;
    lblTel2.ElementFont := efCSS;
    lblTel2.HeightPercent := 100.000000000000000000;
    lblTel2.WidthPercent := 100.000000000000000000;
    lblTel2.Caption := '                                                                  ';
    btnFind.SetParentComponent(Self);
    btnFind.Name := 'btnFind';
    btnFind.AlignWithMargins := True;
    btnFind.Left := 513;
    btnFind.Top := 8;
    btnFind.Width := 61;
    btnFind.Height := 49;
    btnFind.Margins.Left := 10;
    btnFind.Margins.Right := 0;
    btnFind.Caption := '<i class="material-icons">search</i>';
    btnFind.ChildOrder := 1;
    btnFind.Default := True;
    btnFind.ElementClassName := 'btn btn-success';
    btnFind.ElementFont := efCSS;
    btnFind.ElementPosition := epIgnore;
    btnFind.HeightStyle := ssAuto;
    btnFind.HeightPercent := 100.000000000000000000;
    btnFind.WidthStyle := ssAuto;
    btnFind.WidthPercent := 100.000000000000000000;
    SetEvent(btnFind, Self, 'OnClick', 'btnFindClick');
    btnPristanisce.SetParentComponent(Self);
    btnPristanisce.Name := 'btnPristanisce';
    btnPristanisce.AlignWithMargins := True;
    btnPristanisce.Left := 584;
    btnPristanisce.Top := 8;
    btnPristanisce.Width := 61;
    btnPristanisce.Height := 49;
    btnPristanisce.Margins.Left := 10;
    btnPristanisce.Margins.Right := 10;
    btnPristanisce.Caption := '<i class="material-icons">anchor</i>';
    btnPristanisce.ChildOrder := 1;
    btnPristanisce.ElementFont := efCSS;
    btnPristanisce.ElementPosition := epIgnore;
    btnPristanisce.HeightStyle := ssAuto;
    btnPristanisce.HeightPercent := 100.000000000000000000;
    btnPristanisce.WidthStyle := ssAuto;
    btnPristanisce.WidthPercent := 100.000000000000000000;
    SetEvent(btnPristanisce, Self, 'OnClick', 'btnPristanisceClick');
    edtFind.SetParentComponent(Self);
    edtFind.Name := 'edtFind';
    edtFind.Left := 5;
    edtFind.Top := 5;
    edtFind.Width := 498;
    edtFind.Height := 55;
    edtFind.Margins.Left := 10;
    edtFind.Margins.Right := 10;
    edtFind.CharCase := wecUpperCase;
    edtFind.ChildOrder := 5;
    edtFind.ElementClassName := 'form-control text-uppercase';
    edtFind.ElementFont := efCSS;
    edtFind.ElementPosition := epIgnore;
    edtFind.HeightStyle := ssAuto;
    edtFind.HeightPercent := 100.000000000000000000;
    edtFind.WidthStyle := ssAuto;
    edtFind.WidthPercent := 100.000000000000000000;
    SetEvent(edtFind, Self, 'OnKeyDown', 'btnFindKeyDown');
    tmrStart.SetParentComponent(Self);
    tmrStart.Name := 'tmrStart';
    tmrStart.Enabled := False;
    tmrStart.Interval := 100;
    SetEvent(tmrStart, Self, 'OnTimer', 'tmrStartTimer');
    tmrStart.Left := 56;
    tmrStart.Top := 416;
    srcView.SetParentComponent(Self);
    srcView.Name := 'srcView';
    srcView.DataSet := wdsView;
    srcView.Left := 56;
    srcView.Top := 536;
    wdsView.SetParentComponent(Self);
    wdsView.Name := 'wdsView';
    wdsView.AfterOpen := wdsViewAfterOpen;
    wdsView.EntitySetName := 'PrivezView';
    wdsView.Connection := modMain.connServer;
    wdsView.SubpropsDepth := 1;
    wdsView.Left := 56;
    wdsView.Top := 480;
    wdsViewPristanisce.SetParentComponent(wdsView);
    wdsViewPristanisce.Name := 'wdsViewPristanisce';
    wdsViewPristanisce.FieldName := 'Pristanisce';
    wdsViewPristanisceId.SetParentComponent(wdsView);
    wdsViewPristanisceId.Name := 'wdsViewPristanisceId';
    wdsViewPristanisceId.FieldName := 'Pristanisce.Id';
    wdsViewPristanisceNaziv.SetParentComponent(wdsView);
    wdsViewPristanisceNaziv.Name := 'wdsViewPristanisceNaziv';
    wdsViewPristanisceNaziv.FieldName := 'Pristanisce.Naziv';
    wdsViewPristanisceNaziv.Size := 30;
    wdsViewPristaniscePaOddelek.SetParentComponent(wdsView);
    wdsViewPristaniscePaOddelek.Name := 'wdsViewPristaniscePaOddelek';
    wdsViewPristaniscePaOddelek.FieldName := 'Pristanisce.PaOddelek';
    wdsViewPristaniscePaOddelek.Size := 30;
    wdsViewPristanisceExtraDolzinaCenaBrezDDV.SetParentComponent(wdsView);
    wdsViewPristanisceExtraDolzinaCenaBrezDDV.Name := 'wdsViewPristanisceExtraDolzinaCenaBrezDDV';
    wdsViewPristanisceExtraDolzinaCenaBrezDDV.FieldName := 'Pristanisce.ExtraDolzinaCenaBrezDDV';
    wdsViewTipPriveza.SetParentComponent(wdsView);
    wdsViewTipPriveza.Name := 'wdsViewTipPriveza';
    wdsViewTipPriveza.FieldName := 'TipPriveza';
    wdsViewTipPrivezaId.SetParentComponent(wdsView);
    wdsViewTipPrivezaId.Name := 'wdsViewTipPrivezaId';
    wdsViewTipPrivezaId.FieldName := 'TipPriveza.Id';
    wdsViewTipPrivezaNaziv.SetParentComponent(wdsView);
    wdsViewTipPrivezaNaziv.Name := 'wdsViewTipPrivezaNaziv';
    wdsViewTipPrivezaNaziv.FieldName := 'TipPriveza.Naziv';
    wdsViewTipPrivezaNaziv.Size := 30;
    wdsViewOpombeList.SetParentComponent(wdsView);
    wdsViewOpombeList.Name := 'wdsViewOpombeList';
    wdsViewOpombeList.FieldName := 'OpombeList';
    wdsViewOpombeList.ReadOnly := True;
    wdsViewId.SetParentComponent(wdsView);
    wdsViewId.Name := 'wdsViewId';
    wdsViewId.FieldName := 'Id';
    wdsViewId.Required := True;
    wdsViewZapSt.SetParentComponent(wdsView);
    wdsViewZapSt.Name := 'wdsViewZapSt';
    wdsViewZapSt.FieldName := 'ZapSt';
    wdsViewRegSt.SetParentComponent(wdsView);
    wdsViewRegSt.Name := 'wdsViewRegSt';
    wdsViewRegSt.FieldName := 'RegSt';
    wdsViewRegSt.Size := 25;
    wdsViewRegStCista.SetParentComponent(wdsView);
    wdsViewRegStCista.Name := 'wdsViewRegStCista';
    wdsViewRegStCista.FieldName := 'RegStCista';
    wdsViewRegStCista.Size := 25;
    wdsViewDelezLastnistva.SetParentComponent(wdsView);
    wdsViewDelezLastnistva.Name := 'wdsViewDelezLastnistva';
    wdsViewDelezLastnistva.FieldName := 'DelezLastnistva';
    wdsViewDolzina.SetParentComponent(wdsView);
    wdsViewDolzina.Name := 'wdsViewDolzina';
    wdsViewDolzina.FieldName := 'Dolzina';
    wdsViewSirina.SetParentComponent(wdsView);
    wdsViewSirina.Name := 'wdsViewSirina';
    wdsViewSirina.FieldName := 'Sirina';
    wdsViewGlobina.SetParentComponent(wdsView);
    wdsViewGlobina.Name := 'wdsViewGlobina';
    wdsViewGlobina.FieldName := 'Globina';
    wdsViewPantheonId.SetParentComponent(wdsView);
    wdsViewPantheonId.Name := 'wdsViewPantheonId';
    wdsViewPantheonId.FieldName := 'PantheonId';
    wdsViewPantheonId.Size := 200;
    wdsViewPriimekIme.SetParentComponent(wdsView);
    wdsViewPriimekIme.Name := 'wdsViewPriimekIme';
    wdsViewPriimekIme.FieldName := 'PriimekIme';
    wdsViewPriimekIme.Size := 200;
    wdsViewPogodbaSt.SetParentComponent(wdsView);
    wdsViewPogodbaSt.Name := 'wdsViewPogodbaSt';
    wdsViewPogodbaSt.FieldName := 'PogodbaSt';
    wdsViewPogodbaSt.Size := 50;
    wdsViewPogodbaOd.SetParentComponent(wdsView);
    wdsViewPogodbaOd.Name := 'wdsViewPogodbaOd';
    wdsViewPogodbaOd.FieldName := 'PogodbaOd';
    wdsViewPogodbaOd.DisplayFormat := 'dd.mm.yyyy';
    wdsViewPogodbaDo.SetParentComponent(wdsView);
    wdsViewPogodbaDo.Name := 'wdsViewPogodbaDo';
    wdsViewPogodbaDo.FieldName := 'PogodbaDo';
    wdsViewPogodbaDo.DisplayFormat := 'dd.mm.yyyy';
    wdsViewZadnjiAneks.SetParentComponent(wdsView);
    wdsViewZadnjiAneks.Name := 'wdsViewZadnjiAneks';
    wdsViewZadnjiAneks.FieldName := 'ZadnjiAneks';
    wdsViewZadnjiAneks.DisplayFormat := 'dd.mm.yyyy';
    wdsViewOpombe.SetParentComponent(wdsView);
    wdsViewOpombe.Name := 'wdsViewOpombe';
    wdsViewOpombe.FieldName := 'Opombe';
    wdsViewOpombe.Size := 250;
    wdsViewObracun.SetParentComponent(wdsView);
    wdsViewObracun.Name := 'wdsViewObracun';
    wdsViewObracun.FieldName := 'Obracun';
    wdsViewObracun.Required := True;
    wdsViewActive.SetParentComponent(wdsView);
    wdsViewActive.Name := 'wdsViewActive';
    wdsViewActive.FieldName := 'Active';
    wdsViewadTimeChg.SetParentComponent(wdsView);
    wdsViewadTimeChg.Name := 'wdsViewadTimeChg';
    wdsViewadTimeChg.FieldName := 'adTimeChg';
    wdsViewadTimeIns.SetParentComponent(wdsView);
    wdsViewadTimeIns.Name := 'wdsViewadTimeIns';
    wdsViewadTimeIns.FieldName := 'adTimeIns';
    wdsViewanUserChg2.SetParentComponent(wdsView);
    wdsViewanUserChg2.Name := 'wdsViewanUserChg2';
    wdsViewanUserChg2.FieldName := 'anUserChg';
    wdsViewanUserChg2.Size := 25;
    wdsViewPrivez.SetParentComponent(wdsView);
    wdsViewPrivez.Name := 'wdsViewPrivez';
    wdsViewPrivez.FieldName := 'Privez';
    wdsViewPrivezPristanisce.SetParentComponent(wdsView);
    wdsViewPrivezPristanisce.Name := 'wdsViewPrivezPristanisce';
    wdsViewPrivezPristanisce.FieldName := 'Privez.Pristanisce';
    wdsViewPrivezId.SetParentComponent(wdsView);
    wdsViewPrivezId.Name := 'wdsViewPrivezId';
    wdsViewPrivezId.FieldName := 'Privez.Id';
    wdsViewPrivezZapSt.SetParentComponent(wdsView);
    wdsViewPrivezZapSt.Name := 'wdsViewPrivezZapSt';
    wdsViewPrivezZapSt.FieldName := 'Privez.ZapSt';
    wdsViewanUserIns.SetParentComponent(wdsView);
    wdsViewanUserIns.Name := 'wdsViewanUserIns';
    wdsViewanUserIns.FieldName := 'anUserIns';
    wdsViewanUserIns.Size := 25;
    wdsViewTel.SetParentComponent(wdsView);
    wdsViewTel.Name := 'wdsViewTel';
    wdsViewTel.FieldName := 'Tel';
    wdsViewTel.Size := 50;
    wdsViewTel2.SetParentComponent(wdsView);
    wdsViewTel2.Name := 'wdsViewTel2';
    wdsViewTel2.FieldName := 'Tel2';
    wdsViewTel2.Size := 50;
  finally
    lblDolzina.AfterLoadDFMValues;
    lblSirina.AfterLoadDFMValues;
    lblPogodbaSt.AfterLoadDFMValues;
    lblPogodbaOd.AfterLoadDFMValues;
    lblPogodbaDo.AfterLoadDFMValues;
    lblOpombe.AfterLoadDFMValues;
    lblPrivez.AfterLoadDFMValues;
    lblLastnik.AfterLoadDFMValues;
    lblNoData.AfterLoadDFMValues;
    lblRegSt.AfterLoadDFMValues;
    lblTel2.AfterLoadDFMValues;
    btnFind.AfterLoadDFMValues;
    btnPristanisce.AfterLoadDFMValues;
    edtFind.AfterLoadDFMValues;
    tmrStart.AfterLoadDFMValues;
    srcView.AfterLoadDFMValues;
    wdsView.AfterLoadDFMValues;
    wdsViewPristanisce.AfterLoadDFMValues;
    wdsViewPristanisceId.AfterLoadDFMValues;
    wdsViewPristanisceNaziv.AfterLoadDFMValues;
    wdsViewPristaniscePaOddelek.AfterLoadDFMValues;
    wdsViewPristanisceExtraDolzinaCenaBrezDDV.AfterLoadDFMValues;
    wdsViewTipPriveza.AfterLoadDFMValues;
    wdsViewTipPrivezaId.AfterLoadDFMValues;
    wdsViewTipPrivezaNaziv.AfterLoadDFMValues;
    wdsViewOpombeList.AfterLoadDFMValues;
    wdsViewId.AfterLoadDFMValues;
    wdsViewZapSt.AfterLoadDFMValues;
    wdsViewRegSt.AfterLoadDFMValues;
    wdsViewRegStCista.AfterLoadDFMValues;
    wdsViewDelezLastnistva.AfterLoadDFMValues;
    wdsViewDolzina.AfterLoadDFMValues;
    wdsViewSirina.AfterLoadDFMValues;
    wdsViewGlobina.AfterLoadDFMValues;
    wdsViewPantheonId.AfterLoadDFMValues;
    wdsViewPriimekIme.AfterLoadDFMValues;
    wdsViewPogodbaSt.AfterLoadDFMValues;
    wdsViewPogodbaOd.AfterLoadDFMValues;
    wdsViewPogodbaDo.AfterLoadDFMValues;
    wdsViewZadnjiAneks.AfterLoadDFMValues;
    wdsViewOpombe.AfterLoadDFMValues;
    wdsViewObracun.AfterLoadDFMValues;
    wdsViewActive.AfterLoadDFMValues;
    wdsViewadTimeChg.AfterLoadDFMValues;
    wdsViewadTimeIns.AfterLoadDFMValues;
    wdsViewanUserChg2.AfterLoadDFMValues;
    wdsViewPrivez.AfterLoadDFMValues;
    wdsViewPrivezPristanisce.AfterLoadDFMValues;
    wdsViewPrivezId.AfterLoadDFMValues;
    wdsViewPrivezZapSt.AfterLoadDFMValues;
    wdsViewanUserIns.AfterLoadDFMValues;
    wdsViewTel.AfterLoadDFMValues;
    wdsViewTel2.AfterLoadDFMValues;
  end;
end;

end.
